import React from 'react';
import BaseProps from "../types/BaseProps";
import {ConfirmationDialog} from "./Dialog";
import NavigationPrompt from "react-router-navigation-prompt";

type NavigationConfirmationProps = BaseProps & {
  when: boolean,
  message: string | React.ReactElement
}

/**
 * Handler for preventing navigation to another page by showing a confirmation dialog when the
 * provided <code>when</code> property is truthful.
 */
class NavigationConfirmation extends React.Component<NavigationConfirmationProps> {

  render() {
    return (
      <NavigationPrompt when={this.props.when}>
        {({onConfirm, onCancel}) => (
          <ConfirmationDialog
            message={this.props.message}
            onConfirm={onConfirm}
            onCancel={onCancel}/>
        )}
      </NavigationPrompt>
    );
  }
}

/**
 * Registers a handler for unsaved changes that will render a confirmation dialog if the provided
 * <code>when</code> property is truthful.
 */
export function UnsavedChangesConfirmation(props: { when: boolean, message?: any }) {
  const MessageComponent: any = props.message ? props.message : UnsavedChangesMessage;
  return (
    <NavigationConfirmation className="UnsavedChangesConfirmation"
                            {...props}
                            message={<MessageComponent/>}/>
  );
}

function UnsavedChangesMessage() {
  return (
    <p>You have unsaved changes. Are you sure you want to continue?</p>
  );
}
